import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { CategoriesComponent } from './pages/categories/categories.component';
import { CategoryComponent } from './pages/category/category.component';
import { CourseComponent } from './pages/course/course.component';
import { RegisterComponent } from './pages/register/register.component';
import { LoginComponent } from './pages/login/login.component';
import { AccountComponent } from './pages/account/account.component';
import { RecoverComponent } from './pages/recover/recover.component';
import { CompleteRecoveryComponent } from './pages/complete-recovery/complete-recovery.component';
import { StripeComponent } from './pages/stripe/stripe.component';
import { PricingComponent } from './pages/pricing/pricing.component';
import { BasketComponent } from './pages/basket/basket.component';
import { CheckoutComponent } from './pages/checkout/checkout.component';
import { OrdersComponent } from './pages/account/orders/orders.component';
import { OrderComponent } from './pages/account/orders/order/order.component';
import { MycoursesComponent } from './pages/mycourses/mycourses.component';
import { TermsComponent } from './pages/terms/terms.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { CookiesComponent } from './pages/cookies/cookies.component';
import { BlogComponent } from './pages/blog/blog.component';
import { BlogArticleComponent } from './pages/blog-article/blog-article.component';
import { SubscribeComponent } from './pages/subscribe/subscribe.component';
import { PracticeComponent } from './pages/practice/practice.component';
import { ProgrammesComponent } from './pages/programmes/programmes.component';
import { SearchComponent } from './pages/search/search.component';
import { ProgrammeComponent } from './pages/programmes/programme/programme.component';
import { StreamComponent } from './pages/stream/stream.component';
import { AboutComponent } from './pages/about/about.component';
import { ExternalRedirectGuard } from './guards/external-redirect.guard';
import { FaqsComponent } from './pages/faqs/faqs.component';
import { ContactComponent } from './pages/contact/contact.component';
import { SupportComponent } from './pages/support/support.component';
import { TutorsComponent } from './pages/tutors/tutors.component';
import { PressComponent } from './pages/press/press.component';
import { SupportersComponent } from './pages/supporters/supporters.component';
import { WatchingComponent } from './pages/watching/watching.component';
import { WatchlistComponent } from './pages/watchlist/watchlist.component';
import { PracticeContentComponent } from './pages/practice/practice-content/practice-content.component';
import { PracticeConentQuizComponent } from './pages/practice/practice-content/practice-conent-quiz/practice-conent-quiz.component';
import { PracticeContentLessonsComponent } from './pages/practice/practice-content/practice-content-lessons/practice-content-lessons.component';
import { TutorComponent } from './pages/tutors/tutor/tutor.component';
import { SupporterComponent } from './pages/supporters/supporter/supporter.component';
import { StudentsComponent } from './pages/students/students.component';
import { StudentComponent } from './pages/students/student/student.component';
import { VerifyComponent } from './pages/account/verify/verify.component';
import { HistoryComponent } from './pages/account/history/history.component';
import { SeatscriptionComponent } from './pages/seatscription/seatscription.component';
import { PaymentMethodsComponent } from './pages/account/payment-methods/payment-methods.component';
import { TrainingProgrammesComponent } from './pages/training-programmes/training-programmes.component';
import { PracticeContentDocumentsComponent } from './pages/practice/practice-content/practice-content-documents/practice-content-documents.component';
import { RegisterSuccessComponent } from './pages/register/register-success/register-success.component';
import { FreevetComponent } from './pages/freevetcpd/freevet.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'categories', component: CategoriesComponent },
  { path: 'categories/:id', component: CategoryComponent },
  { path: 'course/:id', component: CourseComponent },
  { path: 'stream/:id', component: StreamComponent },
  { path: 'register' , component: RegisterComponent},
  { path: 'register/success', component: RegisterSuccessComponent },
  { path: 'login' , component: LoginComponent},
  { path: 'account' , component: AccountComponent},
  { path: 'account/verify-email/:emailHash', component: VerifyComponent },
  { path: 'account/cpd-record', component: HistoryComponent },
  { path: 'recover' , component: RecoverComponent},
  { path: 'recover/:id' , component: CompleteRecoveryComponent},
  { path: 'stripe' , component: StripeComponent},
  { path: 'pricing' , component: PricingComponent},
  { path: 'basket' , component: BasketComponent},
  { path: 'basket/checkout' , component: CheckoutComponent},
  { path: 'account/orders' , component: OrdersComponent},
  { path: 'account/orders/:id' , component: OrderComponent},
  { path: 'account/payment-methods', component: PaymentMethodsComponent },
  { path: 'mycourses' , component: MycoursesComponent},
  { path: 'terms' , component: TermsComponent},
  { path: 'privacy' , component: PrivacyComponent},
  { path: 'cookies' , component: CookiesComponent},
  { path: 'blog' , component: BlogComponent},
  { path: 'blog/:id' , component: BlogArticleComponent},
  { path: 'subscribe' , component: SubscribeComponent},
  { path: 'practice/seats', component: SeatscriptionComponent},
  { path: 'practice' , component: PracticeComponent},
  { path: 'practice/content/:id' , component: PracticeContentComponent},
  { path: 'practice/content/:id/quiz/:quizId' , component: PracticeConentQuizComponent},
  { path: 'practice/content/:id/lessons' , component: PracticeContentLessonsComponent},
  { path: 'practice/content/:id/documents' , component: PracticeContentDocumentsComponent},
  { path: 'watching', component: WatchingComponent },
  { path: 'watchlist', component: WatchlistComponent },
  { path: 'programmes' , component: ProgrammesComponent},
  { path: 'programmes/programme/:id' , component: ProgrammeComponent},
  { path: 'training-programmes', component: TrainingProgrammesComponent },
  { path: 'training-programmes/:id', component: TrainingProgrammesComponent },
  { path: 'about', component: AboutComponent, canActivate: [ExternalRedirectGuard], data: { externalUrl: 'https://centralcpd.co.uk/about-us/' } },
  { path: 'faqs', component: FaqsComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'support', component: SupportComponent },
  { path: 'tutors', component: TutorsComponent },
  { path: 'tutors/:id', component: TutorComponent },
  { path: 'press', component: PressComponent },
  { path: 'supporters', component: SupportersComponent },
  { path: 'supporters/:id', component: SupporterComponent },
  { path: 'search' , component: SearchComponent},
  { path: 'students', component: StudentsComponent },
  { path: 'students/:id/:pid', component: StudentComponent },
  { path: 'freevetcpd', component: FreevetComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

